const _version = "2.15.8"
function version() {
    return _version
}
export default version
